import colors from "assets/theme/base/colors";
import boxShadow from "assets/theme/functions/boxShadow";

const { black, white, coloredShadows, primary } = colors;

export default {
  /* ---------- Elevation (Soft, Premium) ---------- */

  xs: boxShadow([0, 2], [6, -3], black.main, 0.08),

  sm: boxShadow([0, 4], [10, 0], black.main, 0.1),

  md: `${boxShadow([0, 6], [14, -4], black.main, 0.08)}, 
       ${boxShadow([0, 3], [6, -2], black.main, 0.04)}`,

  lg: `${boxShadow([0, 10], [20, -6], black.main, 0.08)}, 
       ${boxShadow([0, 4], [10, -3], black.main, 0.04)}`,

  xl: `${boxShadow([0, 18], [30, -8], black.main, 0.1)}, 
       ${boxShadow([0, 8], [12, -6], black.main, 0.04)}`,

  xxl: boxShadow([0, 24], [38, -10], black.main, 0.08),

  inset: boxShadow([0, 1], [2, 0], black.main, 0.06, "inset"),

  /* ---------- Colored Shadows (Wine-led) ---------- */

  colored: {
    primary: `${boxShadow([0, 4], [18, 0], black.main, 0.12)}, 
              ${boxShadow([0, 8], [16, -6], coloredShadows.primary, 0.35)}`,

    secondary: `${boxShadow([0, 4], [18, 0], black.main, 0.12)}, 
                ${boxShadow([0, 8], [16, -6], coloredShadows.secondary, 0.25)}`,

    info: `${boxShadow([0, 4], [18, 0], black.main, 0.12)}, 
           ${boxShadow([0, 8], [16, -6], coloredShadows.primary, 0.3)}`,

    success: `${boxShadow([0, 4], [18, 0], black.main, 0.12)}, 
              ${boxShadow([0, 8], [16, -6], coloredShadows.success, 0.3)}`,

    warning: `${boxShadow([0, 4], [18, 0], black.main, 0.12)}, 
              ${boxShadow([0, 8], [16, -6], coloredShadows.warning, 0.3)}`,

    error: `${boxShadow([0, 4], [18, 0], black.main, 0.12)}, 
            ${boxShadow([0, 8], [16, -6], coloredShadows.error, 0.3)}`,

    light: `${boxShadow([0, 4], [18, 0], black.main, 0.08)}, 
            ${boxShadow([0, 8], [16, -6], coloredShadows.light, 0.25)}`,

    dark: `${boxShadow([0, 4], [18, 0], black.main, 0.16)}, 
           ${boxShadow([0, 8], [16, -6], coloredShadows.dark, 0.35)}`,

    white: `${boxShadow([0, 4], [18, 0], white.main, 0.12)}, 
            ${boxShadow([0, 8], [16, -6], white.main, 0.25)}`,
  },

  /* ---------- Components ---------- */

  sliderBoxShadow: {
    thumb: boxShadow([0, 2], [10, 0], primary.main, 0.35),
  },

  tabsBoxShadow: {
    indicator: boxShadow([0, 2], [6, 1], primary.main, 0.6),
  },
};
